import { forwardRef } from 'react';
import type { BlockProps } from '../_block';
import { Block } from '../_block';

export type HtmlBlockProps = BlockProps & {
  code?: string;
};

export const HtmlBlock = forwardRef<HTMLDivElement, HtmlBlockProps>(
  ({ code, ...forwardingProps }, forwardingRef) => {
    const handleClick: BlockProps['onClick'] = (e) => {
      const target = e.target as HTMLDivElement;
      const closestLink = target.closest('a');

      if (e.currentTarget.contains(closestLink)) {
        e.stopPropagation();
      }
    };

    return (
      <Block {...forwardingProps} ref={forwardingRef} onClick={handleClick}>
        {code && <div dangerouslySetInnerHTML={{ __html: code }} />}
      </Block>
    );
  }
);
